module.exports = function(homepageGrid) {
    // Homepage grid progressive enhancements:
    // Find video backgrounds and create the relevant elements
    // No videos on touch
    // Hover divs on touch?
}